import { tabloidItems } from '@/mocks/gossip';

export default function Tabloid() {
  return (
    <section id="xiaobao" className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div className="flex flex-col justify-center rounded-xl bg-secondary-100 p-6 md:p-8">
          <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold tracking-widest text-secondary-800">
            <i className="ri-newspaper-line text-lg" />
            GOSSIP TABLOID
          </p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">小报精选 · 今天的八卦段子</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-700">
            红毯上的一段高情商救场、录影棚里一只抢镜的猫、深夜剧组的一顿盒饭……我们把适合下饭的小报边角料整理成轻快的一栏，正餐之外也给你加个菜。
          </p>
          <div className="mt-6 flex items-center gap-5">
            <div>
              <p className="font-heading text-2xl font-black text-primary-600">24h</p>
              <p className="text-[11px] text-foreground-600">全天滚动</p>
            </div>
            <div className="h-8 w-px bg-secondary-300" />
            <div>
              <p className="font-heading text-2xl font-black text-accent-700">{tabloidItems.length * 8}+</p>
              <p className="text-[11px] text-foreground-600">本周段子</p>
            </div>
            <div className="h-8 w-px bg-secondary-300" />
            <div>
              <p className="font-heading text-2xl font-black text-foreground-950">轻松看</p>
              <p className="text-[11px] text-foreground-600">纯享不费脑</p>
            </div>
          </div>
        </div>

        <ul className="flex flex-col justify-center gap-2.5">
          {tabloidItems.map((t, i) => (
            <li key={t.id}>
              <div className="group flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 px-4 py-3 transition hover:border-accent-300 hover:bg-accent-100/40">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 font-heading text-sm font-black text-accent-800 transition group-hover:bg-accent-500 group-hover:text-background-50">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <p className="min-w-0 flex-1 truncate text-sm text-foreground-800">{t.title}</p>
                <span className="shrink-0 rounded-full bg-secondary-100 px-2.5 py-1 text-[10px] text-secondary-700">{t.tag}</span>
                <span className="shrink-0 text-[11px] text-foreground-400">{t.time}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}